import { Route, Routes } from "react-router-dom";
import { Routes as FleetDriverRoutes } from "./routes";
import { FleetDriverRouterCmp } from "./types";
import { DriverSearchPage } from "../pages/DriverSearchPage";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FleetDriverRouter: FleetDriverRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route path={DriverSearchPage.route} element={<DriverSearchPage />} />
      </Routes>
    </>
  );
};

FleetDriverRouter.route = FleetDriverRoutes.FleetDriverRouter;

export default FleetDriverRouter;
